// extracted by mini-css-extract-plugin
module.exports = {"Circle":"Circle--1ph8v","Done":"Done--3P7Dx","Overdue":"Overdue--17NtJ","Count":"Count--3zW0S"};